import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../Auth/AuthContext";
import { getAndesStatus } from "./agendaApi";

function describe(status) {
	if (!status) return { color: "#9ca3af", label: "ANDES" };
	if (!status.available) return { color: "#dc2626", label: "ANDES caído" };
	if (!status.writesAvailable)
		return { color: "#d97706", label: "ANDES · escrituras caídas" };
	return { color: "#16a34a", label: "ANDES operativo" };
}

/** ANDES availability indicator for the sidebar footer (admins only). */
export default function AndesStatus() {
	const { isAdmin } = useAuth();
	const [status, setStatus] = useState(null);

	const refresh = useCallback(async () => {
		// The status endpoint is admin-only for now.
		if (!isAdmin) return;
		try {
			setStatus(await getAndesStatus());
		} catch {
			// Ignored — interceptor handles real errors.
		}
	}, [isAdmin]);

	useEffect(() => {
		if (!isAdmin) return undefined;
		refresh();
		const id = setInterval(refresh, 15000);
		return () => clearInterval(id);
	}, [refresh, isAdmin]);

	const { color, label } = describe(status);

	return (
		<div className="px-2 py-1.5">
			<div className="flex items-center gap-2 truncate text-xs">
				<span
					className="inline-block size-2 shrink-0 rounded-full"
					style={{ backgroundColor: color }}
				/>
				<span className="text-muted-foreground truncate">{label}</span>
			</div>
		</div>
	);
}
